// PGCET MCA Mock 7 — Computer Awareness (questions 31–55)
const pgcetmcaComputerAwareness = [
  {
    id: 31,
    question: "The binary number (1011.101)₂ in decimal is",
    options: ["A. 11.625", "B. 11.525", "C. 13.625", "D. 11.75"],
    answer: "A"
  },
  {
    id: 32,
    question: "The hexadecimal equivalent of the decimal number (450)₁₀ is",
    options: ["A. 1B2", "B. 1C2", "C. 2C1", "D. 1D2"],
    answer: "B"
  },
  {
    id: 33,
    question: "The BCD (8421) representation of the decimal number 59 is",
    options: ["A. 00111011", "B. 10010101", "C. 01011001", "D. 01011010"],
    answer: "C"
  },
  {
    id: 34,
    question: "The Gray code equivalent of the binary number 1011 is",
    options: ["A. 1101", "B. 1001", "C. 1111", "D. 1110"],
    answer: "D"
  },
  {
    id: 35,
    question: "The Excess-3 code of the decimal digit 7 is",
    options: ["A. 0111", "B. 1010", "C. 1001", "D. 1011"],
    answer: "B"
  },
  {
    id: 36,
    question: "The range of integers that can be represented using 8-bit two's complement representation is",
    options: ["A. −127 to +127", "B. −128 to +128", "C. −128 to +127", "D. 0 to 255"],
    answer: "C"
  },
  {
    id: 37,
    question: "The output of a 2-input XNOR gate is 1 when",
    options: ["A. both inputs are equal", "B. the inputs are different", "C. only the first input is 1", "D. at least one input is 1"],
    answer: "A"
  },
  {
    id: 38,
    question: "A multiplexer with 3 select lines can select one of how many data inputs?",
    options: ["A. 3", "B. 6", "C. 8", "D. 16"],
    answer: "C"
  },
  {
    id: 39,
    question: "Which flip-flop toggles its output when both of its inputs are 1 at the clock edge?",
    options: ["A. SR flip-flop", "B. D flip-flop", "C. Latch with enable", "D. JK flip-flop"],
    answer: "D"
  },
  {
    id: 40,
    question: "For a full adder with inputs A = 1, B = 1 and Cin = 1, the Sum and Carry outputs are respectively",
    options: ["A. 0 and 1", "B. 1 and 0", "C. 1 and 1", "D. 0 and 0"],
    answer: "C"
  },
  {
    id: 41,
    question: "A 4-bit binary ripple up-counter starts at 0000. What does it read after 19 clock pulses?",
    options: ["A. 0011", "B. 0100", "C. 0010", "D. 1011"],
    answer: "A"
  },
  {
    id: 42,
    question: "The number of edges in a complete undirected graph with 8 vertices is",
    options: ["A. 56", "B. 28", "C. 64", "D. 36"],
    answer: "B"
  },
  {
    id: 43,
    question: "Which data structure is used to implement Breadth-First Search (BFS) of a graph?",
    options: ["A. Stack", "B. Heap", "C. Tree", "D. Queue"],
    answer: "D"
  },
  {
    id: 44,
    question: "The minimum possible height of a binary tree with 15 nodes (taking the height of a single-node tree as 0) is",
    options: ["A. 3", "B. 4", "C. 15", "D. 7"],
    answer: "A"
  },
  {
    id: 45,
    question: "Which sorting algorithm has a time complexity of O(n log n) in the best, average and worst cases?",
    options: ["A. Quick Sort", "B. Insertion Sort", "C. Merge Sort", "D. Bubble Sort"],
    answer: "C"
  },
  {
    id: 46,
    question: "A binary tree has 20 leaf nodes. The number of nodes having exactly two children is",
    options: ["A. 20", "B. 21", "C. 10", "D. 19"],
    answer: "D"
  },
  {
    id: 47,
    question: "The prefix (Polish) form of the infix expression A + B * C − D is",
    options: ["A. + A − * B C D", "B. − + A * B C D", "C. * + A B − C D", "D. − * + A B C D"],
    answer: "B"
  },
  {
    id: 48,
    question: "Kruskal's algorithm for finding a minimum spanning tree is based on which design strategy?",
    options: ["A. Dynamic programming", "B. Divide and conquer", "C. Backtracking", "D. Greedy method"],
    answer: "D"
  },
  {
    id: 49,
    question: "A memory unit has 16 address lines and 8 data lines. Its capacity is",
    options: ["A. 16 KB", "B. 32 KB", "C. 64 KB", "D. 128 KB"],
    answer: "C"
  },
  {
    id: 50,
    question: "A 5-stage instruction pipeline has each stage taking 1 ns. Ignoring stalls, the time taken to execute 100 instructions is",
    options: ["A. 500 ns", "B. 104 ns", "C. 100 ns", "D. 105 ns"],
    answer: "B"
  },
  {
    id: 51,
    question: "A cache has a hit ratio of 0.9 and access time of 10 ns; main memory access time is 100 ns. On a miss, the cache is checked first and then main memory is accessed. The average memory access time is",
    options: ["A. 20 ns", "B. 19 ns", "C. 11 ns", "D. 110 ns"],
    answer: "A"
  },
  {
    id: 52,
    question: "In which addressing mode is the operand value itself specified in the instruction?",
    options: ["A. Direct addressing", "B. Indirect addressing", "C. Register addressing", "D. Immediate addressing"],
    answer: "D"
  },
  {
    id: 53,
    question: "Which of the following is an asymmetric-key (public-key) encryption algorithm?",
    options: ["A. AES", "B. DES", "C. RSA", "D. Blowfish"],
    answer: "C"
  },
  {
    id: 54,
    question: "HTTPS secures web communication by running HTTP over",
    options: ["A. SSH", "B. TLS/SSL", "C. FTP", "D. SMTP"],
    answer: "B"
  },
  {
    id: 55,
    question: "A fraudulent e-mail that imitates a trusted source to trick users into revealing passwords or bank details is an example of",
    options: ["A. Phishing", "B. A worm", "C. Denial of Service", "D. Brute-force attack"],
    answer: "A"
  }
];

export default pgcetmcaComputerAwareness;
